import { declareExportAllDeclaration } from '@babel/types';

export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    template: [
        'autocomplete_template',
        data => {
            return {
                id: data.suggestion,
                suggestion: data.suggestion,
                type: data.type,
            };
        },
    ],

    GET: {},
};
